
import React from 'react';
import { Newspaper } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import NewsSection from './NewsSection';

const NewsTabContent: React.FC = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Newspaper className="h-5 w-5 text-primary" />
          Music Industry News
        </CardTitle>
        <CardDescription>
          Stay updated with the latest trends and developments
        </CardDescription>
      </CardHeader>
      <CardContent>
        <NewsSection />
      </CardContent>
    </Card>
  );
};

export default NewsTabContent;
